export default __webpack_public_path__ + "static/media/question-circle-duotone.9e889b42.svg";